import * as React from 'react';
import { SvgIconOriginal, SvgIconPropsType } from 'src/ui/assets/icons/utils';
import { observer } from 'src/utils/mobx-react';

/** TrapIcon1 */
export const TrapIcon1 = observer('TrapIcon1', ({ className }: SvgIconPropsType) => {
    return (
        <SvgIconOriginal
            className={className}
            fill='none'
            height='24'
            viewBox='0 0 24 24'
            width='24'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fill='#E83737'
                d='M24 12c0 9.627-2.373 12-12 12-9.627 0-12-2.373-12-12C0 2.373 2.373 0 12 0c9.627 0 12 2.373 12 12Z'
            />
            <path
                fill='#fff'
                d='M14.338 17h-2.741v-5.442c0-.245.002-.517.007-.813.009-.296.02-.563.034-.8-.119.142-.23.262-.335.363-.1.1-.199.193-.294.28l-1.135.936-1.401-1.722 3.431-2.796h2.434V17Z'
            />
        </SvgIconOriginal>
    );
});

/** TrapIcon2 */
export const TrapIcon2 = observer('TrapIcon2', ({ className }: SvgIconPropsType) => {
    return (
        <SvgIconOriginal
            className={className}
            fill='none'
            height='24'
            viewBox='0 0 24 24'
            width='24'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fill='#055CA9'
                d='M24 12c0 9.627-2.373 12-12 12-9.627 0-12-2.373-12-12C0 2.373 2.373 0 12 0c9.627 0 12 2.373 12 12Z'
            />
            <path
                fill='#fff'
                d='M15.568 16H8.315v-1.777l2.44-2.468a39.45 39.45 0 0 0 1.177-1.272c.282-.319.48-.59.594-.813.114-.223.171-.456.171-.697 0-.297-.095-.51-.287-.643a1.161 1.161 0 0 0-.677-.198 1.94 1.94 0 0 0-.957.273 6.748 6.748 0 0 0-1.087.793L8.206 7.462c.3-.269.62-.524.957-.766a4.39 4.39 0 0 1 1.196-.601c.46-.155 1.021-.233 1.682-.233.68 0 1.267.119 1.764.356.501.237.888.563 1.162.977.273.41.41.878.41 1.402 0 .578-.107 1.096-.321 1.551-.21.452-.527.905-.95 1.36-.424.452-.953.965-1.586 1.539l-.732.656v.069h3.78V16Z'
            />
        </SvgIconOriginal>
    );
});

/** TrapIcon3 */
export const TrapIcon3 = observer('TrapIcon3', ({ className }: SvgIconPropsType) => {
    return (
        <SvgIconOriginal
            className={className}
            fill='none'
            height='24'
            viewBox='0 0 24 24'
            width='24'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fill='#fff'
                d='M24 12c0 9.627-2.373 12-12 12-9.627 0-12-2.373-12-12C0 2.373 2.373 0 12 0c9.627 0 12 2.373 12 12Z'
            />
            <path
                stroke='#C1CCD7'
                d='M12 .5c4.819 0 7.62.606 9.257 2.243C22.894 4.38 23.5 7.181 23.5 12s-.606 7.62-2.243 9.257C19.62 22.894 16.819 23.5 12 23.5s-7.62-.606-9.257-2.243C1.106 19.62.5 16.819.5 12s.606-7.62 2.243-9.257C4.38 1.106 7.181.5 12 .5Z'
            />
            <path
                fill='#020D16'
                d='M15.233 9.173c0 .474-.102.884-.307 1.23-.2.342-.47.622-.807.841a3.826 3.826 0 0 1-1.094.492v.041c.798.1 1.413.344 1.846.732.438.383.656.927.656 1.634 0 .546-.145 1.048-.437 1.503-.292.452-.745.814-1.36 1.087-.616.27-1.406.404-2.373.404-.647 0-1.198-.048-1.654-.144a8.237 8.237 0 0 1-1.326-.396v-2.243a5.708 5.708 0 0 0 2.59.656c.657 0 1.104-.093 1.34-.28a.902.902 0 0 0 .363-.752.973.973 0 0 0-.171-.58c-.114-.16-.326-.283-.636-.37-.305-.086-.745-.13-1.32-.13H9.93v-2.03h.629c.51 0 .913-.045 1.21-.137.3-.09.517-.214.649-.369a.833.833 0 0 0 .198-.547c0-.264-.102-.46-.307-.587-.206-.128-.477-.192-.814-.192-.3 0-.583.041-.848.123a4.358 4.358 0 0 0-.69.274c-.196.1-.344.182-.444.246L8.39 7.874a6.489 6.489 0 0 1 1.421-.718c.538-.196 1.24-.294 2.106-.294 1.03 0 1.839.205 2.427.616.592.41.888.975.888 1.695Z'
            />
        </SvgIconOriginal>
    );
});

/** TrapIcon4 */
export const TrapIcon4 = observer('TrapIcon4', ({ className }: SvgIconPropsType) => {
    return (
        <SvgIconOriginal
            className={className}
            fill='none'
            height='24'
            viewBox='0 0 24 24'
            width='24'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fill='#020D16'
                d='M24 12c0 9.627-2.373 12-12 12-9.627 0-12-2.373-12-12C0 2.373 2.373 0 12 0c9.627 0 12 2.373 12 12Z'
            />
            <path
                fill='#fff'
                d='M15.89 15.065h-1.1V17h-2.667v-1.935H8.138v-1.982l4.156-6.077h2.495v6.043h1.1v2.016Zm-3.767-2.016v-1.162c0-.105.002-.237.007-.397l.014-.478.02-.41a1.33 1.33 0 0 1 .02-.185h-.075a6.412 6.412 0 0 1-.239.513c-.073.132-.168.29-.287.471l-1.107 1.648h1.647Z'
            />
        </SvgIconOriginal>
    );
});

/** TrapIcon5 */
export const TrapIcon5 = observer('TrapIcon5', ({ className }: SvgIconPropsType) => {
    return (
        <SvgIconOriginal
            className={className}
            fill='none'
            height='24'
            viewBox='0 0 24 24'
            width='24'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fill='#FF5700'
                d='M24 12c0 9.627-2.373 12-12 12-9.627 0-12-2.373-12-12C0 2.373 2.373 0 12 0c9.627 0 12 2.373 12 12Z'
            />
            <path
                fill='#fff'
                d='M12.438 10.451c.555 0 1.061.125 1.517.376.456.25.82.615 1.094 1.094.273.478.41 1.062.41 1.75 0 .743-.15 1.374-.451 1.894-.296.514-.745.906-1.347 1.175-.597.265-1.351.397-2.263.397A8.502 8.502 0 0 1 9.813 17a4.896 4.896 0 0 1-1.272-.403v-2.215c.35.16.772.305 1.265.437a5.53 5.53 0 0 0 1.367.192c.332 0 .615-.048.848-.144.232-.096.407-.237.526-.424a1.23 1.23 0 0 0 .184-.69c0-.378-.136-.675-.41-.889-.273-.219-.688-.328-1.244-.328-.25 0-.497.025-.738.075-.242.05-.454.105-.636.164l-.991-.492.376-5.277h5.701v2.249h-3.404l-.123 1.32.444-.083c.155-.027.399-.04.732-.04Z'
            />
        </SvgIconOriginal>
    );
});

/** TrapIcon6 */
export const TrapIcon6 = observer('TrapIcon6', ({ className }: SvgIconPropsType) => {
    return (
        <SvgIconOriginal
            className={className}
            fill='none'
            height='24'
            viewBox='0 0 24 24'
            width='24'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fill='#fff'
                d='M24 12c0 9.627-2.373 12-12 12-9.627 0-12-2.373-12-12C0 2.373 2.373 0 12 0c9.627 0 12 2.373 12 12Z'
            />
            <mask
                id='a'
                width='24'
                height='24'
                x='0'
                y='0'
                maskUnits='userSpaceOnUse'
                style={{ maskType: 'alpha' }}
            >
                <path
                    fill='#fff'
                    d='M24 12c0 9.627-2.373 12-12 12-9.627 0-12-2.373-12-12C0 2.373 2.373 0 12 0c9.627 0 12 2.373 12 12Z'
                />
            </mask>
            <g mask='url(#a)'>
                <path
                    fill='#020D16'
                    d='M14 24h-4V0h4zM8 24H4V0h4zM20 24h-4V0h4z'
                />
                <circle
                    cx='12'
                    cy='12'
                    r='8'
                    fill='#fff'
                />
            </g>
            <path
                stroke='#C1CCD7'
                d='M12 .5c4.819 0 7.62.606 9.257 2.243C22.894 4.38 23.5 7.181 23.5 12s-.606 7.62-2.243 9.257C19.62 22.894 16.819 23.5 12 23.5s-7.62-.606-9.257-2.243C1.106 19.62.5 16.819.5 12s.606-7.62 2.243-9.257C4.38 1.106 7.181.5 12 .5Z'
            />
            <path
                fill='#E83737'
                d='M8.377 12.775c0-.574.041-1.143.123-1.709.082-.57.23-1.105.444-1.606.215-.506.518-.953.91-1.34.391-.392.895-.7 1.51-.923.615-.223 1.365-.335 2.25-.335.195 0 .434.012.717.034.283.023.517.05.704.083V9.09a6.74 6.74 0 0 0-.629-.089 7.487 7.487 0 0 0-.854-.041c-.675 0-1.208.102-1.6.308-.387.2-.668.49-.84.868-.174.378-.274.831-.302 1.36h.083a2.64 2.64 0 0 1 .43-.588c.173-.178.385-.317.636-.417.25-.105.554-.157.91-.157.582 0 1.084.128 1.503.383.42.25.74.617.964 1.1.223.483.335 1.071.335 1.764 0 .747-.144 1.388-.43 1.92a2.9 2.9 0 0 1-1.218 1.218c-.524.278-1.15.417-1.88.417a4.22 4.22 0 0 1-1.497-.26 3.236 3.236 0 0 1-1.196-.793c-.337-.36-.601-.813-.793-1.36-.187-.552-.28-1.201-.28-1.949Zm3.705 2.222c.287 0 .52-.11.697-.328.183-.219.274-.563.274-1.032 0-.379-.076-.675-.226-.889-.146-.219-.385-.328-.718-.328a.959.959 0 0 0-.567.164c-.155.105-.273.24-.355.403a1.133 1.133 0 0 0-.123.513c0 .178.018.355.054.533.041.178.103.34.185.486.086.14.193.257.321.348.128.087.28.13.458.13Z'
            />
        </SvgIconOriginal>
    );
});

/** TrapIconUnnamed */
export const TrapIconUnnamed = observer('TrapIconUnnamed', ({ className }: SvgIconPropsType) => {
    return (
        <SvgIconOriginal
            className={className}
            fill='none'
            height='24'
            viewBox='0 0 24 24'
            width='24'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fill='#C1CCD7'
                d='M24 12c0 9.627-2.373 12-12 12-9.627 0-12-2.373-12-12C0 2.373 2.373 0 12 0c9.627 0 12 2.373 12 12Z'
            />
            <path
                fill='#020D16'
                d='M8.993 10.378c.009-1.017.298-1.81.868-2.38.569-.57 1.353-.854 2.352-.854.942 0 1.684.215 2.226.644.54.43.812 1.031.812 1.806 0 .495-.112.905-.336 1.232-.224.327-.551.677-.98 1.05-.374.336-.65.63-.826.882a1.454 1.454 0 0 0-.266.882H10.98c0-.373.05-.7.154-.98.112-.28.242-.509.392-.686.158-.187.359-.397.602-.63.27-.252.47-.471.602-.658.13-.196.196-.425.196-.686 0-.57-.318-.854-.952-.854-.7 0-1.055.415-1.064 1.246l-1.918-.014Zm2.87 4.312c.354 0 .644.112.868.336.224.224.336.513.336.868s-.112.649-.336.882c-.224.224-.514.336-.868.336-.346 0-.63-.112-.854-.336-.224-.233-.336-.527-.336-.882s.107-.644.322-.868c.224-.224.513-.336.868-.336Z'
                opacity='.5'
            />
        </SvgIconOriginal>
    );
});
